import { Component } from '@angular/core';
import { AbstractSpeedReadingGameSettings } from '@games/core/settings';
import { BlindReadingTyping } from '../typing';

@Component({
  selector: 'msl-blind-reading-settings',
  templateUrl: './blind-reading-settings.component.html',
  styleUrls: ['./blind-reading-settings.component.scss'],
  standalone: false,
})
export class BlindReadingSettingsComponent extends AbstractSpeedReadingGameSettings<BlindReadingTyping> {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
